import { Euro } from 'lucide-react'
import moment from 'moment'
import { useState } from 'react'
import { Button, Modal } from '../ui'
import { useToast } from '../ui/Toast/Toast'

export const AlertDialogUpdatePayment = ({ user, updatePayment }) => {
  const [isOpen, setIsOpen] = useState(false)
  const toast = useToast()
  const localUser = JSON.parse(localStorage.getItem('user'))
  const [price, setPrice] = useState(50)
  const [date, setDate] = useState(moment().format('YYYY-MM'))
  const [loading, setLoading] = useState(false)

  const handleUpdatePayment = async () => {
    setLoading(true)
    try {
      await updatePayment(
        user._id,
        true,
        `${date}-01`,
        price,
        localUser.id,
        localUser.name,
        localUser.lastname
      )
      toast({ title: 'Estado de pago actualizado', status: 'success' })
    } catch (error) {
      toast({
        title: 'Error al actualizar',
        description: 'No se pudo actualizar el estado de pago del usuario.',
        status: 'error',
      })
    } finally {
      setIsOpen(false)
    }
    setLoading(false)
  }

  return (
    <>
      <button
        className="icon-btn icon-btn--primary"
        onClick={() => setIsOpen(true)}
        title="Actualizar pago"
        aria-label="Actualizar pago"
      >
        <Euro size={16} />
      </button>
      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={`Actualizar Pago de ${user?.name || user?.email}`}
        size="sm"
      >
        <p>
          ¿Estás seguro de que quieres actualizar el estado de pago de{' '}
          <strong>{user?.name || user?.email}</strong>?
        </p>
        <div className="form-group" style={{ marginTop: '1rem' }}>
          <label className="form-label">Precio</label>
          <input
            className="form-input"
            type="number"
            value={price}
            onChange={e => setPrice(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label className="form-label">Fecha de pago</label>
          <input
            className="form-input"
            type="month"
            value={date}
            onChange={e => setDate(e.target.value)}
          />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '0.5rem',
            marginTop: '1rem',
          }}
        >
          <Button variant="ghost" onClick={() => setIsOpen(false)}>
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={handleUpdatePayment}
            loading={loading}
          >
            Confirmar
          </Button>
        </div>
      </Modal>
    </>
  )
}
